var _g, _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicRectangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "imagebot_2",
    fill: "#fff",
    strokeWidth: 0.6,
    stroke: "#000000",
    d: "M 5 5 L 5 105 L 105 105 L 105 5 L 5 5 z"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "image/svg+xmlOpenclipartRectangle2012-12-05T06:44:10https://openclipart.org/detail/173527/rectangle-by-jkarthik08-173527jkarthik08squaregeometricshape")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicRectangle);
export default __webpack_public_path__ + "static/media/basicRectangle.dc8abc6995ab8f5691e40c5a77d8e920.svg";
export { ForwardRef as ReactComponent };